<template>
	<p class="horizontal-line-with-text">
		<span> {{text}} </span>
	</p>
</template>

<script>
export default {
  name: "horizontal-line-with-text-inside",
  props: {
    text: {
      type: String
    }
  }
};
</script>

<style lang="scss"
			 scoped>
.horizontal-line-with-text {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #CBD5E1;
  line-height: 0.1em;
  margin: 20px 0;
  // margin: 30px 0;
  span {
    background: #fff;
    color: #CBD5E1;
    padding: 0 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/horizontal-line-with-text-inside.vue